import { Link } from "react-router-dom";
import { Award, ArrowRight } from "lucide-react";
import { EXPERT_CLAIM, EXPERT_TEXT } from "@/lib/about";

/** Encart « spécialiste de la chute de cheveux et de l'alopécie chez la femme afro depuis 2011 ». */
export function ExpertiseBlock({ testid = "expertise-block", compact = false }) {
  return (
    <aside data-testid={testid} className={`flex items-start gap-4 rounded-sm border border-[var(--gold)]/70 bg-[rgba(217,180,106,0.07)] ${compact ? "mt-6 p-4" : "p-6 md:p-8"}`}>
      <Award className={`${compact ? "h-6 w-6" : "h-8 w-8"} shrink-0 text-[var(--gold)]`} />
      <div>
        <p className={`font-display leading-snug text-[var(--gold-soft)] ${compact ? "text-lg" : "text-2xl md:text-3xl"}`}>{EXPERT_CLAIM}</p>
        <p className="mt-2 text-sm leading-relaxed text-[var(--parchment)]/85">{EXPERT_TEXT}</p>
        <Link to="/chute-de-cheveux-alopecie" data-testid={`${testid}-link`} className="mt-3 inline-flex items-center gap-1.5 text-xs font-semibold uppercase tracking-[0.18em] text-[var(--gold-soft)] underline-offset-4 hover:underline">Chute de cheveux et alopécie : nos repères <ArrowRight className="h-3.5 w-3.5" /></Link>
      </div>
    </aside>
  );
}
